import { DeviceReducer, SET_DEVICE_TYPE } from './types';

export const deviceReducer: DeviceReducer = (state, action) => {
  switch (action.type) {
    case SET_DEVICE_TYPE:
      return {
        ...state,
        type: action.payload,
      };
    default:
      return state;
  }
};
